export default "__VITE_PUBLIC_ASSET__90e06593__"